export interface AuthorizedOrganization {
  id: string;
  organizationName: string;
  displayName: string;
}

export interface EnterpriseUnitGrant {
  enterpriseUnitId: string;
}

export interface EnterpriseUnitGrantsForUser {
  content: EnterpriseUnitGrant[];
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED',
  TERMINATED = 'TERMINATED',
}

export interface AddressData {
  city?: string;
  country?: string;
  postalCode?: string;
  state?: string;
  street?: string;
  addressLine2?: string;
  county?: string;
}

export enum AccessType {
  INTERACTIVE = 'INTERACTIVE',
  SERVICE_ACCOUNT = 'SERVICE_ACCOUNT',
  LEGACY = 'LEGACY',
  UNKNOWN = 'UNKNOWN',
}

export enum FederationType {
  FULL = 'FULL',
  PARTIAL = 'PARTIAL',
  NONE = 'NONE',
}

export interface UserData {
  username: string;
  familyName?: string;
  fullName?: string;
  givenName?: string;
  status: UserStatus;
  address?: AddressData;
  email?: string;
  /**MaxLength: 32, Pattern: \+?(\d|\()[\d-\(\) ]*\d */
  telephoneNumber?: string;
  primary?: boolean;
  accessType?: AccessType;
  federationType?: FederationType;
  deviceLogin?: string;
  dateOfBirth?: string;
  displayUsername?: string;
  displayName?: string;
}

function isNcrEmailFormat(email?: string): boolean {
  return email?.endsWith('@ncr.com') ?? false;
}

export function isFederated(user: UserData): boolean {
  if (!user) {
    return false;
  }

  if (user.email && isNcrEmailFormat(user.email)) {
    return true;
  }

  return user.federationType === FederationType.FULL || user.federationType === FederationType.PARTIAL;
}

export function isAliasUser(user: UserData): boolean {
  if (!user) {
    return false;
  }

  return Boolean(user?.deviceLogin);
}
